'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var nthHookTheme = require('@narvar/nth-hook-theme');
var Header_module = require('./Header.module.css.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

const HugeHeader = ({
  containerCustomStyle,
  children,
  as = 'h1',
  headerTextRole
}) => {
  const {
    headersHugeNone: hugeHeaderStyle
  } = nthHookTheme.useTheme();
  const Element = as;
  return /*#__PURE__*/React__default["default"].createElement(Element, {
    className: Header_module["default"].hugeHeader,
    style: {
      ...containerCustomStyle,
      ...hugeHeaderStyle
    },
    role: headerTextRole
  }, children);
};
const BigHeader = ({
  containerCustomStyle,
  children,
  as = 'h2',
  headerTextRole
}) => {
  const {
    headersBigNone: bigHeaderStyle
  } = nthHookTheme.useTheme();
  const Element = as;
  return /*#__PURE__*/React__default["default"].createElement(Element, {
    className: Header_module["default"].bigHeader,
    style: {
      ...containerCustomStyle,
      ...bigHeaderStyle
    },
    role: headerTextRole
  }, children);
};
const SemibigHeader = ({
  containerCustomStyle,
  children,
  as = 'h3',
  headerTextRole
}) => {
  const {
    headersSemibigNone: semibigHeaderStyle
  } = nthHookTheme.useTheme();
  const Element = as;
  return /*#__PURE__*/React__default["default"].createElement(Element, {
    className: Header_module["default"].semiBigHeader,
    style: {
      ...containerCustomStyle,
      ...semibigHeaderStyle
    },
    role: headerTextRole
  }, children);
};
const MediumHeader = ({
  containerCustomStyle,
  children,
  as = 'h4',
  headerTextRole
}) => {
  const {
    headersMediumNone: mediumHeaderStyle
  } = nthHookTheme.useTheme();
  const Element = as;
  return /*#__PURE__*/React__default["default"].createElement(Element, {
    className: Header_module["default"].mediumHeader,
    style: {
      ...containerCustomStyle,
      ...mediumHeaderStyle
    },
    role: headerTextRole
  }, children);
};
const SmallHeader = ({
  containerCustomStyle,
  children,
  as = 'h5',
  headerTextRole
}) => {
  const {
    headersSmallNone: smallHeaderStyle
  } = nthHookTheme.useTheme();
  const Element = as;
  return /*#__PURE__*/React__default["default"].createElement(Element, {
    className: Header_module["default"].smallHeader,
    style: {
      ...containerCustomStyle,
      ...smallHeaderStyle
    },
    role: headerTextRole
  }, children);
};
const ThemedHugeHeader = nthHookTheme.withThemeProvider(HugeHeader, {
  themeTokens: ['headersHugeNone']
});
const ThemedBigHeader = nthHookTheme.withThemeProvider(BigHeader, {
  themeTokens: ['headersBigNone']
});
const ThemedSemibigHeader = nthHookTheme.withThemeProvider(SemibigHeader, {
  themeTokens: ['headersSemibigNone']
});
const ThemedMediumHeader = nthHookTheme.withThemeProvider(MediumHeader, {
  themeTokens: ['headersMediumNone']
});
const ThemedSmallHeader = nthHookTheme.withThemeProvider(SmallHeader, {
  themeTokens: ['headersSmallNone']
});

exports.BigHeader = ThemedBigHeader;
exports.HugeHeader = ThemedHugeHeader;
exports.MediumHeader = ThemedMediumHeader;
exports.SemibigHeader = ThemedSemibigHeader;
exports.SmallHeader = ThemedSmallHeader;
